import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, isAnalyticsEnabled, trackPageView } from '../../analytics/gtag';

const PageViewTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) {
      return undefined;
    }

    let cancelled = false;
    const pagePath = `${pathname}${search}`;

    initAnalytics().then(() => {
      if (!cancelled) {
        trackPageView(pagePath);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [pathname, search]);

  return null;
};

export default PageViewTracker;
